import { render } from "./DocumentDetailsTree.vue?vue&type=template&id=8c4376cc&scoped=true&ts=true"
import script from "./DocumentDetailsTree.vue?vue&type=script&lang=ts"
export * from "./DocumentDetailsTree.vue?vue&type=script&lang=ts"

import "./DocumentDetailsTree.vue?vue&type=style&index=0&id=8c4376cc&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4376cc"]])

export default __exports__